/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DevRouteImport } from './routes/dev'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as UnsubscribedRouteImport } from './routes/unsubscribed'
import { Route as DevEmailsRouteImport } from './routes/dev.emails'
import { Route as DevOfficePreviewRouteImport } from './routes/dev.office-preview'
import { Route as DevProgressRouteImport } from './routes/dev.progress'
import { Route as FSlugRouteImport } from './routes/f.$slug'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as WWorkspaceIdRouteImport } from './routes/w.$workspaceId'
import { Route as ShareClipTokenRouteImport } from './routes/share.clip.$token'
import { Route as ShareDocTokenRouteImport } from './routes/share.doc.$token'
import { Route as WWorkspaceIdIndexRouteImport } from './routes/w.$workspaceId.index'
import { Route as WWorkspaceIdChatRouteImport } from './routes/w.$workspaceId.chat'
import { Route as WWorkspaceIdClipsRouteImport } from './routes/w.$workspaceId.clips'
import { Route as WWorkspaceIdDashboardsRouteImport } from './routes/w.$workspaceId.dashboards'
import { Route as WWorkspaceIdDocsRouteImport } from './routes/w.$workspaceId.docs'
import { Route as WWorkspaceIdEverythingRouteImport } from './routes/w.$workspaceId.everything'
import { Route as WWorkspaceIdFormsRouteImport } from './routes/w.$workspaceId.forms'
import { Route as WWorkspaceIdHomeRouteImport } from './routes/w.$workspaceId.home'
import { Route as WWorkspaceIdInboxRouteImport } from './routes/w.$workspaceId.inbox'
import { Route as WWorkspaceIdOfficeRouteImport } from './routes/w.$workspaceId.office'
import { Route as WWorkspaceIdPlannerRouteImport } from './routes/w.$workspaceId.planner'
import { Route as WWorkspaceIdTimesheetRouteImport } from './routes/w.$workspaceId.timesheet'
import { Route as WWorkspaceIdTrashRouteImport } from './routes/w.$workspaceId.trash'
import { Route as WWorkspaceIdWhiteboardsRouteImport } from './routes/w.$workspaceId.whiteboards'
import { Route as WWorkspaceIdChatIndexRouteImport } from './routes/w.$workspaceId.chat.index'
import { Route as WWorkspaceIdChatChannelIdRouteImport } from './routes/w.$workspaceId.chat.$channelId'
import { Route as WWorkspaceIdClipsIndexRouteImport } from './routes/w.$workspaceId.clips.index'
import { Route as WWorkspaceIdClipsClipIdRouteImport } from './routes/w.$workspaceId.clips.$clipId'
import { Route as WWorkspaceIdDashboardsIndexRouteImport } from './routes/w.$workspaceId.dashboards.index'
import { Route as WWorkspaceIdDashboardsDashboardIdRouteImport } from './routes/w.$workspaceId.dashboards.$dashboardId'
import { Route as WWorkspaceIdDocsIndexRouteImport } from './routes/w.$workspaceId.docs.index'
import { Route as WWorkspaceIdDocsDocIdRouteImport } from './routes/w.$workspaceId.docs.$docId'
import { Route as WWorkspaceIdFFolderIdRouteImport } from './routes/w.$workspaceId.f.$folderId'
import { Route as WWorkspaceIdFormsIndexRouteImport } from './routes/w.$workspaceId.forms.index'
import { Route as WWorkspaceIdFormsFormIdRouteImport } from './routes/w.$workspaceId.forms.$formId'
import { Route as WWorkspaceIdLListIdRouteImport } from './routes/w.$workspaceId.l.$listId'
import { Route as WWorkspaceIdMyAssignedRouteImport } from './routes/w.$workspaceId.my.assigned'
import { Route as WWorkspaceIdMyPersonalRouteImport } from './routes/w.$workspaceId.my.personal'
import { Route as WWorkspaceIdMyTodayRouteImport } from './routes/w.$workspaceId.my.today'
import { Route as WWorkspaceIdOfficeIndexRouteImport } from './routes/w.$workspaceId.office.index'
import { Route as WWorkspaceIdOfficeFloorIdRouteImport } from './routes/w.$workspaceId.office.$floorId'
import { Route as WWorkspaceIdSSpaceIdRouteImport } from './routes/w.$workspaceId.s.$spaceId'
import { Route as WWorkspaceIdSettingsAuditRouteImport } from './routes/w.$workspaceId.settings.audit'
import { Route as WWorkspaceIdSettingsAutomationsRouteImport } from './routes/w.$workspaceId.settings.automations'
import { Route as WWorkspaceIdSettingsGeneralRouteImport } from './routes/w.$workspaceId.settings.general'
import { Route as WWorkspaceIdSettingsImportRouteImport } from './routes/w.$workspaceId.settings.import'
import { Route as WWorkspaceIdSettingsIntegrationsRouteImport } from './routes/w.$workspaceId.settings.integrations'
import { Route as WWorkspaceIdSettingsMembersRouteImport } from './routes/w.$workspaceId.settings.members'
import { Route as WWorkspaceIdSettingsNotificationsRouteImport } from './routes/w.$workspaceId.settings.notifications'
import { Route as WWorkspaceIdSettingsTeamsRouteImport } from './routes/w.$workspaceId.settings.teams'
import { Route as WWorkspaceIdSettingsTemplatesRouteImport } from './routes/w.$workspaceId.settings.templates'
import { Route as WWorkspaceIdTTaskIdRouteImport } from './routes/w.$workspaceId.t.$taskId'
import { Route as WWorkspaceIdWhiteboardsIndexRouteImport } from './routes/w.$workspaceId.whiteboards.index'
import { Route as WWorkspaceIdWhiteboardsBoardIdRouteImport } from './routes/w.$workspaceId.whiteboards.$boardId'
import { Route as WWorkspaceIdOfficeFloorIdEditRouteImport } from './routes/w.$workspaceId.office.$floorId_.edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribedRoute = UnsubscribedRouteImport.update({
  id: '/unsubscribed',
  path: '/unsubscribed',
  getParentRoute: () => rootRouteImport,
} as any)
const DevEmailsRoute = DevEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => DevRoute,
} as any)
const DevOfficePreviewRoute = DevOfficePreviewRouteImport.update({
  id: '/office-preview',
  path: '/office-preview',
  getParentRoute: () => DevRoute,
} as any)
const DevProgressRoute = DevProgressRouteImport.update({
  id: '/progress',
  path: '/progress',
  getParentRoute: () => DevRoute,
} as any)
const FSlugRoute = FSlugRouteImport.update({
  id: '/f/$slug',
  path: '/f/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdRoute = WWorkspaceIdRouteImport.update({
  id: '/w/$workspaceId',
  path: '/w/$workspaceId',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareClipTokenRoute = ShareClipTokenRouteImport.update({
  id: '/share/clip/$token',
  path: '/share/clip/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareDocTokenRoute = ShareDocTokenRouteImport.update({
  id: '/share/doc/$token',
  path: '/share/doc/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdIndexRoute = WWorkspaceIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdChatRoute = WWorkspaceIdChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdClipsRoute = WWorkspaceIdClipsRouteImport.update({
  id: '/clips',
  path: '/clips',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdDashboardsRoute = WWorkspaceIdDashboardsRouteImport.update({
  id: '/dashboards',
  path: '/dashboards',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdDocsRoute = WWorkspaceIdDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdEverythingRoute = WWorkspaceIdEverythingRouteImport.update({
  id: '/everything',
  path: '/everything',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdFormsRoute = WWorkspaceIdFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdHomeRoute = WWorkspaceIdHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdInboxRoute = WWorkspaceIdInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdOfficeRoute = WWorkspaceIdOfficeRouteImport.update({
  id: '/office',
  path: '/office',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdPlannerRoute = WWorkspaceIdPlannerRouteImport.update({
  id: '/planner',
  path: '/planner',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdTimesheetRoute = WWorkspaceIdTimesheetRouteImport.update({
  id: '/timesheet',
  path: '/timesheet',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdTrashRoute = WWorkspaceIdTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdWhiteboardsRoute = WWorkspaceIdWhiteboardsRouteImport.update({
  id: '/whiteboards',
  path: '/whiteboards',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdChatIndexRoute = WWorkspaceIdChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWorkspaceIdChatRoute,
} as any)
const WWorkspaceIdChatChannelIdRoute =
  WWorkspaceIdChatChannelIdRouteImport.update({
    id: '/$channelId',
    path: '/$channelId',
    getParentRoute: () => WWorkspaceIdChatRoute,
  } as any)
const WWorkspaceIdClipsIndexRoute = WWorkspaceIdClipsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWorkspaceIdClipsRoute,
} as any)
const WWorkspaceIdClipsClipIdRoute = WWorkspaceIdClipsClipIdRouteImport.update({
  id: '/$clipId',
  path: '/$clipId',
  getParentRoute: () => WWorkspaceIdClipsRoute,
} as any)
const WWorkspaceIdDashboardsIndexRoute =
  WWorkspaceIdDashboardsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WWorkspaceIdDashboardsRoute,
  } as any)
const WWorkspaceIdDashboardsDashboardIdRoute =
  WWorkspaceIdDashboardsDashboardIdRouteImport.update({
    id: '/$dashboardId',
    path: '/$dashboardId',
    getParentRoute: () => WWorkspaceIdDashboardsRoute,
  } as any)
const WWorkspaceIdDocsIndexRoute = WWorkspaceIdDocsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWorkspaceIdDocsRoute,
} as any)
const WWorkspaceIdDocsDocIdRoute = WWorkspaceIdDocsDocIdRouteImport.update({
  id: '/$docId',
  path: '/$docId',
  getParentRoute: () => WWorkspaceIdDocsRoute,
} as any)
const WWorkspaceIdFFolderIdRoute = WWorkspaceIdFFolderIdRouteImport.update({
  id: '/f/$folderId',
  path: '/f/$folderId',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdFormsIndexRoute = WWorkspaceIdFormsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWorkspaceIdFormsRoute,
} as any)
const WWorkspaceIdFormsFormIdRoute = WWorkspaceIdFormsFormIdRouteImport.update({
  id: '/$formId',
  path: '/$formId',
  getParentRoute: () => WWorkspaceIdFormsRoute,
} as any)
const WWorkspaceIdLListIdRoute = WWorkspaceIdLListIdRouteImport.update({
  id: '/l/$listId',
  path: '/l/$listId',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdMyAssignedRoute = WWorkspaceIdMyAssignedRouteImport.update({
  id: '/my/assigned',
  path: '/my/assigned',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdMyPersonalRoute = WWorkspaceIdMyPersonalRouteImport.update({
  id: '/my/personal',
  path: '/my/personal',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdMyTodayRoute = WWorkspaceIdMyTodayRouteImport.update({
  id: '/my/today',
  path: '/my/today',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdOfficeIndexRoute = WWorkspaceIdOfficeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWorkspaceIdOfficeRoute,
} as any)
const WWorkspaceIdOfficeFloorIdRoute =
  WWorkspaceIdOfficeFloorIdRouteImport.update({
    id: '/$floorId',
    path: '/$floorId',
    getParentRoute: () => WWorkspaceIdOfficeRoute,
  } as any)
const WWorkspaceIdSSpaceIdRoute = WWorkspaceIdSSpaceIdRouteImport.update({
  id: '/s/$spaceId',
  path: '/s/$spaceId',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdSettingsAuditRoute =
  WWorkspaceIdSettingsAuditRouteImport.update({
    id: '/settings/audit',
    path: '/settings/audit',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSettingsAutomationsRoute =
  WWorkspaceIdSettingsAutomationsRouteImport.update({
    id: '/settings/automations',
    path: '/settings/automations',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSettingsGeneralRoute =
  WWorkspaceIdSettingsGeneralRouteImport.update({
    id: '/settings/general',
    path: '/settings/general',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSettingsImportRoute =
  WWorkspaceIdSettingsImportRouteImport.update({
    id: '/settings/import',
    path: '/settings/import',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSettingsIntegrationsRoute =
  WWorkspaceIdSettingsIntegrationsRouteImport.update({
    id: '/settings/integrations',
    path: '/settings/integrations',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSettingsMembersRoute =
  WWorkspaceIdSettingsMembersRouteImport.update({
    id: '/settings/members',
    path: '/settings/members',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSettingsNotificationsRoute =
  WWorkspaceIdSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSettingsTeamsRoute =
  WWorkspaceIdSettingsTeamsRouteImport.update({
    id: '/settings/teams',
    path: '/settings/teams',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSettingsTemplatesRoute =
  WWorkspaceIdSettingsTemplatesRouteImport.update({
    id: '/settings/templates',
    path: '/settings/templates',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdTTaskIdRoute = WWorkspaceIdTTaskIdRouteImport.update({
  id: '/t/$taskId',
  path: '/t/$taskId',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdWhiteboardsIndexRoute =
  WWorkspaceIdWhiteboardsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WWorkspaceIdWhiteboardsRoute,
  } as any)
const WWorkspaceIdWhiteboardsBoardIdRoute =
  WWorkspaceIdWhiteboardsBoardIdRouteImport.update({
    id: '/$boardId',
    path: '/$boardId',
    getParentRoute: () => WWorkspaceIdWhiteboardsRoute,
  } as any)
const WWorkspaceIdOfficeFloorIdEditRoute =
  WWorkspaceIdOfficeFloorIdEditRouteImport.update({
    id: '/$floorId_/edit',
    path: '/$floorId/edit',
    getParentRoute: () => WWorkspaceIdOfficeRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dev': typeof DevRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/unsubscribed': typeof UnsubscribedRoute
  '/dev/emails': typeof DevEmailsRoute
  '/dev/office-preview': typeof DevOfficePreviewRoute
  '/dev/progress': typeof DevProgressRoute
  '/f/$slug': typeof FSlugRoute
  '/invite/$token': typeof InviteTokenRoute
  '/w/$workspaceId': typeof WWorkspaceIdRouteWithChildren
  '/share/clip/$token': typeof ShareClipTokenRoute
  '/share/doc/$token': typeof ShareDocTokenRoute
  '/w/$workspaceId/chat': typeof WWorkspaceIdChatRouteWithChildren
  '/w/$workspaceId/clips': typeof WWorkspaceIdClipsRouteWithChildren
  '/w/$workspaceId/dashboards': typeof WWorkspaceIdDashboardsRouteWithChildren
  '/w/$workspaceId/docs': typeof WWorkspaceIdDocsRouteWithChildren
  '/w/$workspaceId/everything': typeof WWorkspaceIdEverythingRoute
  '/w/$workspaceId/forms': typeof WWorkspaceIdFormsRouteWithChildren
  '/w/$workspaceId/home': typeof WWorkspaceIdHomeRoute
  '/w/$workspaceId/inbox': typeof WWorkspaceIdInboxRoute
  '/w/$workspaceId/office': typeof WWorkspaceIdOfficeRouteWithChildren
  '/w/$workspaceId/planner': typeof WWorkspaceIdPlannerRoute
  '/w/$workspaceId/timesheet': typeof WWorkspaceIdTimesheetRoute
  '/w/$workspaceId/trash': typeof WWorkspaceIdTrashRoute
  '/w/$workspaceId/whiteboards': typeof WWorkspaceIdWhiteboardsRouteWithChildren
  '/w/$workspaceId/': typeof WWorkspaceIdIndexRoute
  '/w/$workspaceId/chat/$channelId': typeof WWorkspaceIdChatChannelIdRoute
  '/w/$workspaceId/clips/$clipId': typeof WWorkspaceIdClipsClipIdRoute
  '/w/$workspaceId/dashboards/$dashboardId': typeof WWorkspaceIdDashboardsDashboardIdRoute
  '/w/$workspaceId/docs/$docId': typeof WWorkspaceIdDocsDocIdRoute
  '/w/$workspaceId/f/$folderId': typeof WWorkspaceIdFFolderIdRoute
  '/w/$workspaceId/forms/$formId': typeof WWorkspaceIdFormsFormIdRoute
  '/w/$workspaceId/l/$listId': typeof WWorkspaceIdLListIdRoute
  '/w/$workspaceId/my/assigned': typeof WWorkspaceIdMyAssignedRoute
  '/w/$workspaceId/my/personal': typeof WWorkspaceIdMyPersonalRoute
  '/w/$workspaceId/my/today': typeof WWorkspaceIdMyTodayRoute
  '/w/$workspaceId/office/$floorId': typeof WWorkspaceIdOfficeFloorIdRoute
  '/w/$workspaceId/s/$spaceId': typeof WWorkspaceIdSSpaceIdRoute
  '/w/$workspaceId/settings/audit': typeof WWorkspaceIdSettingsAuditRoute
  '/w/$workspaceId/settings/automations': typeof WWorkspaceIdSettingsAutomationsRoute
  '/w/$workspaceId/settings/general': typeof WWorkspaceIdSettingsGeneralRoute
  '/w/$workspaceId/settings/import': typeof WWorkspaceIdSettingsImportRoute
  '/w/$workspaceId/settings/integrations': typeof WWorkspaceIdSettingsIntegrationsRoute
  '/w/$workspaceId/settings/members': typeof WWorkspaceIdSettingsMembersRoute
  '/w/$workspaceId/settings/notifications': typeof WWorkspaceIdSettingsNotificationsRoute
  '/w/$workspaceId/settings/teams': typeof WWorkspaceIdSettingsTeamsRoute
  '/w/$workspaceId/settings/templates': typeof WWorkspaceIdSettingsTemplatesRoute
  '/w/$workspaceId/t/$taskId': typeof WWorkspaceIdTTaskIdRoute
  '/w/$workspaceId/whiteboards/$boardId': typeof WWorkspaceIdWhiteboardsBoardIdRoute
  '/w/$workspaceId/chat/': typeof WWorkspaceIdChatIndexRoute
  '/w/$workspaceId/clips/': typeof WWorkspaceIdClipsIndexRoute
  '/w/$workspaceId/dashboards/': typeof WWorkspaceIdDashboardsIndexRoute
  '/w/$workspaceId/docs/': typeof WWorkspaceIdDocsIndexRoute
  '/w/$workspaceId/forms/': typeof WWorkspaceIdFormsIndexRoute
  '/w/$workspaceId/office/': typeof WWorkspaceIdOfficeIndexRoute
  '/w/$workspaceId/whiteboards/': typeof WWorkspaceIdWhiteboardsIndexRoute
  '/w/$workspaceId/office/$floorId/edit': typeof WWorkspaceIdOfficeFloorIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dev': typeof DevRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/unsubscribed': typeof UnsubscribedRoute
  '/dev/emails': typeof DevEmailsRoute
  '/dev/office-preview': typeof DevOfficePreviewRoute
  '/dev/progress': typeof DevProgressRoute
  '/f/$slug': typeof FSlugRoute
  '/invite/$token': typeof InviteTokenRoute
  '/share/clip/$token': typeof ShareClipTokenRoute
  '/share/doc/$token': typeof ShareDocTokenRoute
  '/w/$workspaceId/everything': typeof WWorkspaceIdEverythingRoute
  '/w/$workspaceId/home': typeof WWorkspaceIdHomeRoute
  '/w/$workspaceId/inbox': typeof WWorkspaceIdInboxRoute
  '/w/$workspaceId/planner': typeof WWorkspaceIdPlannerRoute
  '/w/$workspaceId/timesheet': typeof WWorkspaceIdTimesheetRoute
  '/w/$workspaceId/trash': typeof WWorkspaceIdTrashRoute
  '/w/$workspaceId': typeof WWorkspaceIdIndexRoute
  '/w/$workspaceId/chat/$channelId': typeof WWorkspaceIdChatChannelIdRoute
  '/w/$workspaceId/clips/$clipId': typeof WWorkspaceIdClipsClipIdRoute
  '/w/$workspaceId/dashboards/$dashboardId': typeof WWorkspaceIdDashboardsDashboardIdRoute
  '/w/$workspaceId/docs/$docId': typeof WWorkspaceIdDocsDocIdRoute
  '/w/$workspaceId/f/$folderId': typeof WWorkspaceIdFFolderIdRoute
  '/w/$workspaceId/forms/$formId': typeof WWorkspaceIdFormsFormIdRoute
  '/w/$workspaceId/l/$listId': typeof WWorkspaceIdLListIdRoute
  '/w/$workspaceId/my/assigned': typeof WWorkspaceIdMyAssignedRoute
  '/w/$workspaceId/my/personal': typeof WWorkspaceIdMyPersonalRoute
  '/w/$workspaceId/my/today': typeof WWorkspaceIdMyTodayRoute
  '/w/$workspaceId/office/$floorId': typeof WWorkspaceIdOfficeFloorIdRoute
  '/w/$workspaceId/s/$spaceId': typeof WWorkspaceIdSSpaceIdRoute
  '/w/$workspaceId/settings/audit': typeof WWorkspaceIdSettingsAuditRoute
  '/w/$workspaceId/settings/automations': typeof WWorkspaceIdSettingsAutomationsRoute
  '/w/$workspaceId/settings/general': typeof WWorkspaceIdSettingsGeneralRoute
  '/w/$workspaceId/settings/import': typeof WWorkspaceIdSettingsImportRoute
  '/w/$workspaceId/settings/integrations': typeof WWorkspaceIdSettingsIntegrationsRoute
  '/w/$workspaceId/settings/members': typeof WWorkspaceIdSettingsMembersRoute
  '/w/$workspaceId/settings/notifications': typeof WWorkspaceIdSettingsNotificationsRoute
  '/w/$workspaceId/settings/teams': typeof WWorkspaceIdSettingsTeamsRoute
  '/w/$workspaceId/settings/templates': typeof WWorkspaceIdSettingsTemplatesRoute
  '/w/$workspaceId/t/$taskId': typeof WWorkspaceIdTTaskIdRoute
  '/w/$workspaceId/whiteboards/$boardId': typeof WWorkspaceIdWhiteboardsBoardIdRoute
  '/w/$workspaceId/chat': typeof WWorkspaceIdChatIndexRoute
  '/w/$workspaceId/clips': typeof WWorkspaceIdClipsIndexRoute
  '/w/$workspaceId/dashboards': typeof WWorkspaceIdDashboardsIndexRoute
  '/w/$workspaceId/docs': typeof WWorkspaceIdDocsIndexRoute
  '/w/$workspaceId/forms': typeof WWorkspaceIdFormsIndexRoute
  '/w/$workspaceId/office': typeof WWorkspaceIdOfficeIndexRoute
  '/w/$workspaceId/whiteboards': typeof WWorkspaceIdWhiteboardsIndexRoute
  '/w/$workspaceId/office/$floorId/edit': typeof WWorkspaceIdOfficeFloorIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dev': typeof DevRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/unsubscribed': typeof UnsubscribedRoute
  '/dev/emails': typeof DevEmailsRoute
  '/dev/office-preview': typeof DevOfficePreviewRoute
  '/dev/progress': typeof DevProgressRoute
  '/f/$slug': typeof FSlugRoute
  '/invite/$token': typeof InviteTokenRoute
  '/w/$workspaceId': typeof WWorkspaceIdRouteWithChildren
  '/share/clip/$token': typeof ShareClipTokenRoute
  '/share/doc/$token': typeof ShareDocTokenRoute
  '/w/$workspaceId/chat': typeof WWorkspaceIdChatRouteWithChildren
  '/w/$workspaceId/clips': typeof WWorkspaceIdClipsRouteWithChildren
  '/w/$workspaceId/dashboards': typeof WWorkspaceIdDashboardsRouteWithChildren
  '/w/$workspaceId/docs': typeof WWorkspaceIdDocsRouteWithChildren
  '/w/$workspaceId/everything': typeof WWorkspaceIdEverythingRoute
  '/w/$workspaceId/forms': typeof WWorkspaceIdFormsRouteWithChildren
  '/w/$workspaceId/home': typeof WWorkspaceIdHomeRoute
  '/w/$workspaceId/inbox': typeof WWorkspaceIdInboxRoute
  '/w/$workspaceId/office': typeof WWorkspaceIdOfficeRouteWithChildren
  '/w/$workspaceId/planner': typeof WWorkspaceIdPlannerRoute
  '/w/$workspaceId/timesheet': typeof WWorkspaceIdTimesheetRoute
  '/w/$workspaceId/trash': typeof WWorkspaceIdTrashRoute
  '/w/$workspaceId/whiteboards': typeof WWorkspaceIdWhiteboardsRouteWithChildren
  '/w/$workspaceId/': typeof WWorkspaceIdIndexRoute
  '/w/$workspaceId/chat/$channelId': typeof WWorkspaceIdChatChannelIdRoute
  '/w/$workspaceId/clips/$clipId': typeof WWorkspaceIdClipsClipIdRoute
  '/w/$workspaceId/dashboards/$dashboardId': typeof WWorkspaceIdDashboardsDashboardIdRoute
  '/w/$workspaceId/docs/$docId': typeof WWorkspaceIdDocsDocIdRoute
  '/w/$workspaceId/f/$folderId': typeof WWorkspaceIdFFolderIdRoute
  '/w/$workspaceId/forms/$formId': typeof WWorkspaceIdFormsFormIdRoute
  '/w/$workspaceId/l/$listId': typeof WWorkspaceIdLListIdRoute
  '/w/$workspaceId/my/assigned': typeof WWorkspaceIdMyAssignedRoute
  '/w/$workspaceId/my/personal': typeof WWorkspaceIdMyPersonalRoute
  '/w/$workspaceId/my/today': typeof WWorkspaceIdMyTodayRoute
  '/w/$workspaceId/office/$floorId': typeof WWorkspaceIdOfficeFloorIdRoute
  '/w/$workspaceId/s/$spaceId': typeof WWorkspaceIdSSpaceIdRoute
  '/w/$workspaceId/settings/audit': typeof WWorkspaceIdSettingsAuditRoute
  '/w/$workspaceId/settings/automations': typeof WWorkspaceIdSettingsAutomationsRoute
  '/w/$workspaceId/settings/general': typeof WWorkspaceIdSettingsGeneralRoute
  '/w/$workspaceId/settings/import': typeof WWorkspaceIdSettingsImportRoute
  '/w/$workspaceId/settings/integrations': typeof WWorkspaceIdSettingsIntegrationsRoute
  '/w/$workspaceId/settings/members': typeof WWorkspaceIdSettingsMembersRoute
  '/w/$workspaceId/settings/notifications': typeof WWorkspaceIdSettingsNotificationsRoute
  '/w/$workspaceId/settings/teams': typeof WWorkspaceIdSettingsTeamsRoute
  '/w/$workspaceId/settings/templates': typeof WWorkspaceIdSettingsTemplatesRoute
  '/w/$workspaceId/t/$taskId': typeof WWorkspaceIdTTaskIdRoute
  '/w/$workspaceId/whiteboards/$boardId': typeof WWorkspaceIdWhiteboardsBoardIdRoute
  '/w/$workspaceId/chat/': typeof WWorkspaceIdChatIndexRoute
  '/w/$workspaceId/clips/': typeof WWorkspaceIdClipsIndexRoute
  '/w/$workspaceId/dashboards/': typeof WWorkspaceIdDashboardsIndexRoute
  '/w/$workspaceId/docs/': typeof WWorkspaceIdDocsIndexRoute
  '/w/$workspaceId/forms/': typeof WWorkspaceIdFormsIndexRoute
  '/w/$workspaceId/office/': typeof WWorkspaceIdOfficeIndexRoute
  '/w/$workspaceId/whiteboards/': typeof WWorkspaceIdWhiteboardsIndexRoute
  '/w/$workspaceId/office/$floorId_/edit': typeof WWorkspaceIdOfficeFloorIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dev'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/signup'
    | '/unsubscribed'
    | '/dev/emails'
    | '/dev/office-preview'
    | '/dev/progress'
    | '/f/$slug'
    | '/invite/$token'
    | '/w/$workspaceId'
    | '/share/clip/$token'
    | '/share/doc/$token'
    | '/w/$workspaceId/chat'
    | '/w/$workspaceId/clips'
    | '/w/$workspaceId/dashboards'
    | '/w/$workspaceId/docs'
    | '/w/$workspaceId/everything'
    | '/w/$workspaceId/forms'
    | '/w/$workspaceId/home'
    | '/w/$workspaceId/inbox'
    | '/w/$workspaceId/office'
    | '/w/$workspaceId/planner'
    | '/w/$workspaceId/timesheet'
    | '/w/$workspaceId/trash'
    | '/w/$workspaceId/whiteboards'
    | '/w/$workspaceId/'
    | '/w/$workspaceId/chat/$channelId'
    | '/w/$workspaceId/clips/$clipId'
    | '/w/$workspaceId/dashboards/$dashboardId'
    | '/w/$workspaceId/docs/$docId'
    | '/w/$workspaceId/f/$folderId'
    | '/w/$workspaceId/forms/$formId'
    | '/w/$workspaceId/l/$listId'
    | '/w/$workspaceId/my/assigned'
    | '/w/$workspaceId/my/personal'
    | '/w/$workspaceId/my/today'
    | '/w/$workspaceId/office/$floorId'
    | '/w/$workspaceId/s/$spaceId'
    | '/w/$workspaceId/settings/audit'
    | '/w/$workspaceId/settings/automations'
    | '/w/$workspaceId/settings/general'
    | '/w/$workspaceId/settings/import'
    | '/w/$workspaceId/settings/integrations'
    | '/w/$workspaceId/settings/members'
    | '/w/$workspaceId/settings/notifications'
    | '/w/$workspaceId/settings/teams'
    | '/w/$workspaceId/settings/templates'
    | '/w/$workspaceId/t/$taskId'
    | '/w/$workspaceId/whiteboards/$boardId'
    | '/w/$workspaceId/chat/'
    | '/w/$workspaceId/clips/'
    | '/w/$workspaceId/dashboards/'
    | '/w/$workspaceId/docs/'
    | '/w/$workspaceId/forms/'
    | '/w/$workspaceId/office/'
    | '/w/$workspaceId/whiteboards/'
    | '/w/$workspaceId/office/$floorId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dev'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/signup'
    | '/unsubscribed'
    | '/dev/emails'
    | '/dev/office-preview'
    | '/dev/progress'
    | '/f/$slug'
    | '/invite/$token'
    | '/share/clip/$token'
    | '/share/doc/$token'
    | '/w/$workspaceId/everything'
    | '/w/$workspaceId/home'
    | '/w/$workspaceId/inbox'
    | '/w/$workspaceId/planner'
    | '/w/$workspaceId/timesheet'
    | '/w/$workspaceId/trash'
    | '/w/$workspaceId'
    | '/w/$workspaceId/chat/$channelId'
    | '/w/$workspaceId/clips/$clipId'
    | '/w/$workspaceId/dashboards/$dashboardId'
    | '/w/$workspaceId/docs/$docId'
    | '/w/$workspaceId/f/$folderId'
    | '/w/$workspaceId/forms/$formId'
    | '/w/$workspaceId/l/$listId'
    | '/w/$workspaceId/my/assigned'
    | '/w/$workspaceId/my/personal'
    | '/w/$workspaceId/my/today'
    | '/w/$workspaceId/office/$floorId'
    | '/w/$workspaceId/s/$spaceId'
    | '/w/$workspaceId/settings/audit'
    | '/w/$workspaceId/settings/automations'
    | '/w/$workspaceId/settings/general'
    | '/w/$workspaceId/settings/import'
    | '/w/$workspaceId/settings/integrations'
    | '/w/$workspaceId/settings/members'
    | '/w/$workspaceId/settings/notifications'
    | '/w/$workspaceId/settings/teams'
    | '/w/$workspaceId/settings/templates'
    | '/w/$workspaceId/t/$taskId'
    | '/w/$workspaceId/whiteboards/$boardId'
    | '/w/$workspaceId/chat'
    | '/w/$workspaceId/clips'
    | '/w/$workspaceId/dashboards'
    | '/w/$workspaceId/docs'
    | '/w/$workspaceId/forms'
    | '/w/$workspaceId/office'
    | '/w/$workspaceId/whiteboards'
    | '/w/$workspaceId/office/$floorId/edit'
  id:
    | '__root__'
    | '/'
    | '/dev'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/signup'
    | '/unsubscribed'
    | '/dev/emails'
    | '/dev/office-preview'
    | '/dev/progress'
    | '/f/$slug'
    | '/invite/$token'
    | '/w/$workspaceId'
    | '/share/clip/$token'
    | '/share/doc/$token'
    | '/w/$workspaceId/chat'
    | '/w/$workspaceId/clips'
    | '/w/$workspaceId/dashboards'
    | '/w/$workspaceId/docs'
    | '/w/$workspaceId/everything'
    | '/w/$workspaceId/forms'
    | '/w/$workspaceId/home'
    | '/w/$workspaceId/inbox'
    | '/w/$workspaceId/office'
    | '/w/$workspaceId/planner'
    | '/w/$workspaceId/timesheet'
    | '/w/$workspaceId/trash'
    | '/w/$workspaceId/whiteboards'
    | '/w/$workspaceId/'
    | '/w/$workspaceId/chat/$channelId'
    | '/w/$workspaceId/clips/$clipId'
    | '/w/$workspaceId/dashboards/$dashboardId'
    | '/w/$workspaceId/docs/$docId'
    | '/w/$workspaceId/f/$folderId'
    | '/w/$workspaceId/forms/$formId'
    | '/w/$workspaceId/l/$listId'
    | '/w/$workspaceId/my/assigned'
    | '/w/$workspaceId/my/personal'
    | '/w/$workspaceId/my/today'
    | '/w/$workspaceId/office/$floorId'
    | '/w/$workspaceId/s/$spaceId'
    | '/w/$workspaceId/settings/audit'
    | '/w/$workspaceId/settings/automations'
    | '/w/$workspaceId/settings/general'
    | '/w/$workspaceId/settings/import'
    | '/w/$workspaceId/settings/integrations'
    | '/w/$workspaceId/settings/members'
    | '/w/$workspaceId/settings/notifications'
    | '/w/$workspaceId/settings/teams'
    | '/w/$workspaceId/settings/templates'
    | '/w/$workspaceId/t/$taskId'
    | '/w/$workspaceId/whiteboards/$boardId'
    | '/w/$workspaceId/chat/'
    | '/w/$workspaceId/clips/'
    | '/w/$workspaceId/dashboards/'
    | '/w/$workspaceId/docs/'
    | '/w/$workspaceId/forms/'
    | '/w/$workspaceId/office/'
    | '/w/$workspaceId/whiteboards/'
    | '/w/$workspaceId/office/$floorId_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DevRoute: typeof DevRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  UnsubscribedRoute: typeof UnsubscribedRoute
  FSlugRoute: typeof FSlugRoute
  InviteTokenRoute: typeof InviteTokenRoute
  WWorkspaceIdRoute: typeof WWorkspaceIdRouteWithChildren
  ShareClipTokenRoute: typeof ShareClipTokenRoute
  ShareDocTokenRoute: typeof ShareDocTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribed': {
      id: '/unsubscribed'
      path: '/unsubscribed'
      fullPath: '/unsubscribed'
      preLoaderRoute: typeof UnsubscribedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/emails': {
      id: '/dev/emails'
      path: '/emails'
      fullPath: '/dev/emails'
      preLoaderRoute: typeof DevEmailsRouteImport
      parentRoute: typeof DevRoute
    }
    '/dev/office-preview': {
      id: '/dev/office-preview'
      path: '/office-preview'
      fullPath: '/dev/office-preview'
      preLoaderRoute: typeof DevOfficePreviewRouteImport
      parentRoute: typeof DevRoute
    }
    '/dev/progress': {
      id: '/dev/progress'
      path: '/progress'
      fullPath: '/dev/progress'
      preLoaderRoute: typeof DevProgressRouteImport
      parentRoute: typeof DevRoute
    }
    '/f/$slug': {
      id: '/f/$slug'
      path: '/f/$slug'
      fullPath: '/f/$slug'
      preLoaderRoute: typeof FSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId': {
      id: '/w/$workspaceId'
      path: '/w/$workspaceId'
      fullPath: '/w/$workspaceId'
      preLoaderRoute: typeof WWorkspaceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/clip/$token': {
      id: '/share/clip/$token'
      path: '/share/clip/$token'
      fullPath: '/share/clip/$token'
      preLoaderRoute: typeof ShareClipTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/doc/$token': {
      id: '/share/doc/$token'
      path: '/share/doc/$token'
      fullPath: '/share/doc/$token'
      preLoaderRoute: typeof ShareDocTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/': {
      id: '/w/$workspaceId/'
      path: '/'
      fullPath: '/w/$workspaceId/'
      preLoaderRoute: typeof WWorkspaceIdIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/chat': {
      id: '/w/$workspaceId/chat'
      path: '/chat'
      fullPath: '/w/$workspaceId/chat'
      preLoaderRoute: typeof WWorkspaceIdChatRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/clips': {
      id: '/w/$workspaceId/clips'
      path: '/clips'
      fullPath: '/w/$workspaceId/clips'
      preLoaderRoute: typeof WWorkspaceIdClipsRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/dashboards': {
      id: '/w/$workspaceId/dashboards'
      path: '/dashboards'
      fullPath: '/w/$workspaceId/dashboards'
      preLoaderRoute: typeof WWorkspaceIdDashboardsRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/docs': {
      id: '/w/$workspaceId/docs'
      path: '/docs'
      fullPath: '/w/$workspaceId/docs'
      preLoaderRoute: typeof WWorkspaceIdDocsRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/everything': {
      id: '/w/$workspaceId/everything'
      path: '/everything'
      fullPath: '/w/$workspaceId/everything'
      preLoaderRoute: typeof WWorkspaceIdEverythingRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/forms': {
      id: '/w/$workspaceId/forms'
      path: '/forms'
      fullPath: '/w/$workspaceId/forms'
      preLoaderRoute: typeof WWorkspaceIdFormsRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/home': {
      id: '/w/$workspaceId/home'
      path: '/home'
      fullPath: '/w/$workspaceId/home'
      preLoaderRoute: typeof WWorkspaceIdHomeRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/inbox': {
      id: '/w/$workspaceId/inbox'
      path: '/inbox'
      fullPath: '/w/$workspaceId/inbox'
      preLoaderRoute: typeof WWorkspaceIdInboxRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/office': {
      id: '/w/$workspaceId/office'
      path: '/office'
      fullPath: '/w/$workspaceId/office'
      preLoaderRoute: typeof WWorkspaceIdOfficeRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/planner': {
      id: '/w/$workspaceId/planner'
      path: '/planner'
      fullPath: '/w/$workspaceId/planner'
      preLoaderRoute: typeof WWorkspaceIdPlannerRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/timesheet': {
      id: '/w/$workspaceId/timesheet'
      path: '/timesheet'
      fullPath: '/w/$workspaceId/timesheet'
      preLoaderRoute: typeof WWorkspaceIdTimesheetRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/trash': {
      id: '/w/$workspaceId/trash'
      path: '/trash'
      fullPath: '/w/$workspaceId/trash'
      preLoaderRoute: typeof WWorkspaceIdTrashRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/whiteboards': {
      id: '/w/$workspaceId/whiteboards'
      path: '/whiteboards'
      fullPath: '/w/$workspaceId/whiteboards'
      preLoaderRoute: typeof WWorkspaceIdWhiteboardsRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/chat/': {
      id: '/w/$workspaceId/chat/'
      path: '/'
      fullPath: '/w/$workspaceId/chat/'
      preLoaderRoute: typeof WWorkspaceIdChatIndexRouteImport
      parentRoute: typeof WWorkspaceIdChatRoute
    }
    '/w/$workspaceId/chat/$channelId': {
      id: '/w/$workspaceId/chat/$channelId'
      path: '/$channelId'
      fullPath: '/w/$workspaceId/chat/$channelId'
      preLoaderRoute: typeof WWorkspaceIdChatChannelIdRouteImport
      parentRoute: typeof WWorkspaceIdChatRoute
    }
    '/w/$workspaceId/clips/': {
      id: '/w/$workspaceId/clips/'
      path: '/'
      fullPath: '/w/$workspaceId/clips/'
      preLoaderRoute: typeof WWorkspaceIdClipsIndexRouteImport
      parentRoute: typeof WWorkspaceIdClipsRoute
    }
    '/w/$workspaceId/clips/$clipId': {
      id: '/w/$workspaceId/clips/$clipId'
      path: '/$clipId'
      fullPath: '/w/$workspaceId/clips/$clipId'
      preLoaderRoute: typeof WWorkspaceIdClipsClipIdRouteImport
      parentRoute: typeof WWorkspaceIdClipsRoute
    }
    '/w/$workspaceId/dashboards/': {
      id: '/w/$workspaceId/dashboards/'
      path: '/'
      fullPath: '/w/$workspaceId/dashboards/'
      preLoaderRoute: typeof WWorkspaceIdDashboardsIndexRouteImport
      parentRoute: typeof WWorkspaceIdDashboardsRoute
    }
    '/w/$workspaceId/dashboards/$dashboardId': {
      id: '/w/$workspaceId/dashboards/$dashboardId'
      path: '/$dashboardId'
      fullPath: '/w/$workspaceId/dashboards/$dashboardId'
      preLoaderRoute: typeof WWorkspaceIdDashboardsDashboardIdRouteImport
      parentRoute: typeof WWorkspaceIdDashboardsRoute
    }
    '/w/$workspaceId/docs/': {
      id: '/w/$workspaceId/docs/'
      path: '/'
      fullPath: '/w/$workspaceId/docs/'
      preLoaderRoute: typeof WWorkspaceIdDocsIndexRouteImport
      parentRoute: typeof WWorkspaceIdDocsRoute
    }
    '/w/$workspaceId/docs/$docId': {
      id: '/w/$workspaceId/docs/$docId'
      path: '/$docId'
      fullPath: '/w/$workspaceId/docs/$docId'
      preLoaderRoute: typeof WWorkspaceIdDocsDocIdRouteImport
      parentRoute: typeof WWorkspaceIdDocsRoute
    }
    '/w/$workspaceId/f/$folderId': {
      id: '/w/$workspaceId/f/$folderId'
      path: '/f/$folderId'
      fullPath: '/w/$workspaceId/f/$folderId'
      preLoaderRoute: typeof WWorkspaceIdFFolderIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/forms/': {
      id: '/w/$workspaceId/forms/'
      path: '/'
      fullPath: '/w/$workspaceId/forms/'
      preLoaderRoute: typeof WWorkspaceIdFormsIndexRouteImport
      parentRoute: typeof WWorkspaceIdFormsRoute
    }
    '/w/$workspaceId/forms/$formId': {
      id: '/w/$workspaceId/forms/$formId'
      path: '/$formId'
      fullPath: '/w/$workspaceId/forms/$formId'
      preLoaderRoute: typeof WWorkspaceIdFormsFormIdRouteImport
      parentRoute: typeof WWorkspaceIdFormsRoute
    }
    '/w/$workspaceId/l/$listId': {
      id: '/w/$workspaceId/l/$listId'
      path: '/l/$listId'
      fullPath: '/w/$workspaceId/l/$listId'
      preLoaderRoute: typeof WWorkspaceIdLListIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/my/assigned': {
      id: '/w/$workspaceId/my/assigned'
      path: '/my/assigned'
      fullPath: '/w/$workspaceId/my/assigned'
      preLoaderRoute: typeof WWorkspaceIdMyAssignedRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/my/personal': {
      id: '/w/$workspaceId/my/personal'
      path: '/my/personal'
      fullPath: '/w/$workspaceId/my/personal'
      preLoaderRoute: typeof WWorkspaceIdMyPersonalRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/my/today': {
      id: '/w/$workspaceId/my/today'
      path: '/my/today'
      fullPath: '/w/$workspaceId/my/today'
      preLoaderRoute: typeof WWorkspaceIdMyTodayRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/office/': {
      id: '/w/$workspaceId/office/'
      path: '/'
      fullPath: '/w/$workspaceId/office/'
      preLoaderRoute: typeof WWorkspaceIdOfficeIndexRouteImport
      parentRoute: typeof WWorkspaceIdOfficeRoute
    }
    '/w/$workspaceId/office/$floorId': {
      id: '/w/$workspaceId/office/$floorId'
      path: '/$floorId'
      fullPath: '/w/$workspaceId/office/$floorId'
      preLoaderRoute: typeof WWorkspaceIdOfficeFloorIdRouteImport
      parentRoute: typeof WWorkspaceIdOfficeRoute
    }
    '/w/$workspaceId/s/$spaceId': {
      id: '/w/$workspaceId/s/$spaceId'
      path: '/s/$spaceId'
      fullPath: '/w/$workspaceId/s/$spaceId'
      preLoaderRoute: typeof WWorkspaceIdSSpaceIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/settings/audit': {
      id: '/w/$workspaceId/settings/audit'
      path: '/settings/audit'
      fullPath: '/w/$workspaceId/settings/audit'
      preLoaderRoute: typeof WWorkspaceIdSettingsAuditRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/settings/automations': {
      id: '/w/$workspaceId/settings/automations'
      path: '/settings/automations'
      fullPath: '/w/$workspaceId/settings/automations'
      preLoaderRoute: typeof WWorkspaceIdSettingsAutomationsRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/settings/general': {
      id: '/w/$workspaceId/settings/general'
      path: '/settings/general'
      fullPath: '/w/$workspaceId/settings/general'
      preLoaderRoute: typeof WWorkspaceIdSettingsGeneralRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/settings/import': {
      id: '/w/$workspaceId/settings/import'
      path: '/settings/import'
      fullPath: '/w/$workspaceId/settings/import'
      preLoaderRoute: typeof WWorkspaceIdSettingsImportRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/settings/integrations': {
      id: '/w/$workspaceId/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/w/$workspaceId/settings/integrations'
      preLoaderRoute: typeof WWorkspaceIdSettingsIntegrationsRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/settings/members': {
      id: '/w/$workspaceId/settings/members'
      path: '/settings/members'
      fullPath: '/w/$workspaceId/settings/members'
      preLoaderRoute: typeof WWorkspaceIdSettingsMembersRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/settings/notifications': {
      id: '/w/$workspaceId/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/w/$workspaceId/settings/notifications'
      preLoaderRoute: typeof WWorkspaceIdSettingsNotificationsRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/settings/teams': {
      id: '/w/$workspaceId/settings/teams'
      path: '/settings/teams'
      fullPath: '/w/$workspaceId/settings/teams'
      preLoaderRoute: typeof WWorkspaceIdSettingsTeamsRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/settings/templates': {
      id: '/w/$workspaceId/settings/templates'
      path: '/settings/templates'
      fullPath: '/w/$workspaceId/settings/templates'
      preLoaderRoute: typeof WWorkspaceIdSettingsTemplatesRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/t/$taskId': {
      id: '/w/$workspaceId/t/$taskId'
      path: '/t/$taskId'
      fullPath: '/w/$workspaceId/t/$taskId'
      preLoaderRoute: typeof WWorkspaceIdTTaskIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/whiteboards/': {
      id: '/w/$workspaceId/whiteboards/'
      path: '/'
      fullPath: '/w/$workspaceId/whiteboards/'
      preLoaderRoute: typeof WWorkspaceIdWhiteboardsIndexRouteImport
      parentRoute: typeof WWorkspaceIdWhiteboardsRoute
    }
    '/w/$workspaceId/whiteboards/$boardId': {
      id: '/w/$workspaceId/whiteboards/$boardId'
      path: '/$boardId'
      fullPath: '/w/$workspaceId/whiteboards/$boardId'
      preLoaderRoute: typeof WWorkspaceIdWhiteboardsBoardIdRouteImport
      parentRoute: typeof WWorkspaceIdWhiteboardsRoute
    }
    '/w/$workspaceId/office/$floorId_/edit': {
      id: '/w/$workspaceId/office/$floorId_/edit'
      path: '/$floorId/edit'
      fullPath: '/w/$workspaceId/office/$floorId/edit'
      preLoaderRoute: typeof WWorkspaceIdOfficeFloorIdEditRouteImport
      parentRoute: typeof WWorkspaceIdOfficeRoute
    }
  }
}

interface DevRouteChildren {
  DevEmailsRoute: typeof DevEmailsRoute
  DevOfficePreviewRoute: typeof DevOfficePreviewRoute
  DevProgressRoute: typeof DevProgressRoute
}

const DevRouteChildren: DevRouteChildren = {
  DevEmailsRoute: DevEmailsRoute,
  DevOfficePreviewRoute: DevOfficePreviewRoute,
  DevProgressRoute: DevProgressRoute,
}

const DevRouteWithChildren = DevRoute._addFileChildren(DevRouteChildren)

interface WWorkspaceIdChatRouteChildren {
  WWorkspaceIdChatChannelIdRoute: typeof WWorkspaceIdChatChannelIdRoute
  WWorkspaceIdChatIndexRoute: typeof WWorkspaceIdChatIndexRoute
}

const WWorkspaceIdChatRouteChildren: WWorkspaceIdChatRouteChildren = {
  WWorkspaceIdChatChannelIdRoute: WWorkspaceIdChatChannelIdRoute,
  WWorkspaceIdChatIndexRoute: WWorkspaceIdChatIndexRoute,
}

const WWorkspaceIdChatRouteWithChildren =
  WWorkspaceIdChatRoute._addFileChildren(WWorkspaceIdChatRouteChildren)

interface WWorkspaceIdClipsRouteChildren {
  WWorkspaceIdClipsClipIdRoute: typeof WWorkspaceIdClipsClipIdRoute
  WWorkspaceIdClipsIndexRoute: typeof WWorkspaceIdClipsIndexRoute
}

const WWorkspaceIdClipsRouteChildren: WWorkspaceIdClipsRouteChildren = {
  WWorkspaceIdClipsClipIdRoute: WWorkspaceIdClipsClipIdRoute,
  WWorkspaceIdClipsIndexRoute: WWorkspaceIdClipsIndexRoute,
}

const WWorkspaceIdClipsRouteWithChildren =
  WWorkspaceIdClipsRoute._addFileChildren(WWorkspaceIdClipsRouteChildren)

interface WWorkspaceIdDashboardsRouteChildren {
  WWorkspaceIdDashboardsDashboardIdRoute: typeof WWorkspaceIdDashboardsDashboardIdRoute
  WWorkspaceIdDashboardsIndexRoute: typeof WWorkspaceIdDashboardsIndexRoute
}

const WWorkspaceIdDashboardsRouteChildren: WWorkspaceIdDashboardsRouteChildren =
  {
    WWorkspaceIdDashboardsDashboardIdRoute:
      WWorkspaceIdDashboardsDashboardIdRoute,
    WWorkspaceIdDashboardsIndexRoute: WWorkspaceIdDashboardsIndexRoute,
  }

const WWorkspaceIdDashboardsRouteWithChildren =
  WWorkspaceIdDashboardsRoute._addFileChildren(
    WWorkspaceIdDashboardsRouteChildren,
  )

interface WWorkspaceIdDocsRouteChildren {
  WWorkspaceIdDocsDocIdRoute: typeof WWorkspaceIdDocsDocIdRoute
  WWorkspaceIdDocsIndexRoute: typeof WWorkspaceIdDocsIndexRoute
}

const WWorkspaceIdDocsRouteChildren: WWorkspaceIdDocsRouteChildren = {
  WWorkspaceIdDocsDocIdRoute: WWorkspaceIdDocsDocIdRoute,
  WWorkspaceIdDocsIndexRoute: WWorkspaceIdDocsIndexRoute,
}

const WWorkspaceIdDocsRouteWithChildren =
  WWorkspaceIdDocsRoute._addFileChildren(WWorkspaceIdDocsRouteChildren)

interface WWorkspaceIdFormsRouteChildren {
  WWorkspaceIdFormsFormIdRoute: typeof WWorkspaceIdFormsFormIdRoute
  WWorkspaceIdFormsIndexRoute: typeof WWorkspaceIdFormsIndexRoute
}

const WWorkspaceIdFormsRouteChildren: WWorkspaceIdFormsRouteChildren = {
  WWorkspaceIdFormsFormIdRoute: WWorkspaceIdFormsFormIdRoute,
  WWorkspaceIdFormsIndexRoute: WWorkspaceIdFormsIndexRoute,
}

const WWorkspaceIdFormsRouteWithChildren =
  WWorkspaceIdFormsRoute._addFileChildren(WWorkspaceIdFormsRouteChildren)

interface WWorkspaceIdOfficeRouteChildren {
  WWorkspaceIdOfficeFloorIdRoute: typeof WWorkspaceIdOfficeFloorIdRoute
  WWorkspaceIdOfficeIndexRoute: typeof WWorkspaceIdOfficeIndexRoute
  WWorkspaceIdOfficeFloorIdEditRoute: typeof WWorkspaceIdOfficeFloorIdEditRoute
}

const WWorkspaceIdOfficeRouteChildren: WWorkspaceIdOfficeRouteChildren = {
  WWorkspaceIdOfficeFloorIdRoute: WWorkspaceIdOfficeFloorIdRoute,
  WWorkspaceIdOfficeIndexRoute: WWorkspaceIdOfficeIndexRoute,
  WWorkspaceIdOfficeFloorIdEditRoute: WWorkspaceIdOfficeFloorIdEditRoute,
}

const WWorkspaceIdOfficeRouteWithChildren =
  WWorkspaceIdOfficeRoute._addFileChildren(WWorkspaceIdOfficeRouteChildren)

interface WWorkspaceIdWhiteboardsRouteChildren {
  WWorkspaceIdWhiteboardsBoardIdRoute: typeof WWorkspaceIdWhiteboardsBoardIdRoute
  WWorkspaceIdWhiteboardsIndexRoute: typeof WWorkspaceIdWhiteboardsIndexRoute
}

const WWorkspaceIdWhiteboardsRouteChildren: WWorkspaceIdWhiteboardsRouteChildren =
  {
    WWorkspaceIdWhiteboardsBoardIdRoute: WWorkspaceIdWhiteboardsBoardIdRoute,
    WWorkspaceIdWhiteboardsIndexRoute: WWorkspaceIdWhiteboardsIndexRoute,
  }

const WWorkspaceIdWhiteboardsRouteWithChildren =
  WWorkspaceIdWhiteboardsRoute._addFileChildren(
    WWorkspaceIdWhiteboardsRouteChildren,
  )

interface WWorkspaceIdRouteChildren {
  WWorkspaceIdChatRoute: typeof WWorkspaceIdChatRouteWithChildren
  WWorkspaceIdClipsRoute: typeof WWorkspaceIdClipsRouteWithChildren
  WWorkspaceIdDashboardsRoute: typeof WWorkspaceIdDashboardsRouteWithChildren
  WWorkspaceIdDocsRoute: typeof WWorkspaceIdDocsRouteWithChildren
  WWorkspaceIdEverythingRoute: typeof WWorkspaceIdEverythingRoute
  WWorkspaceIdFormsRoute: typeof WWorkspaceIdFormsRouteWithChildren
  WWorkspaceIdHomeRoute: typeof WWorkspaceIdHomeRoute
  WWorkspaceIdInboxRoute: typeof WWorkspaceIdInboxRoute
  WWorkspaceIdOfficeRoute: typeof WWorkspaceIdOfficeRouteWithChildren
  WWorkspaceIdPlannerRoute: typeof WWorkspaceIdPlannerRoute
  WWorkspaceIdTimesheetRoute: typeof WWorkspaceIdTimesheetRoute
  WWorkspaceIdTrashRoute: typeof WWorkspaceIdTrashRoute
  WWorkspaceIdWhiteboardsRoute: typeof WWorkspaceIdWhiteboardsRouteWithChildren
  WWorkspaceIdIndexRoute: typeof WWorkspaceIdIndexRoute
  WWorkspaceIdFFolderIdRoute: typeof WWorkspaceIdFFolderIdRoute
  WWorkspaceIdLListIdRoute: typeof WWorkspaceIdLListIdRoute
  WWorkspaceIdMyAssignedRoute: typeof WWorkspaceIdMyAssignedRoute
  WWorkspaceIdMyPersonalRoute: typeof WWorkspaceIdMyPersonalRoute
  WWorkspaceIdMyTodayRoute: typeof WWorkspaceIdMyTodayRoute
  WWorkspaceIdSSpaceIdRoute: typeof WWorkspaceIdSSpaceIdRoute
  WWorkspaceIdSettingsAuditRoute: typeof WWorkspaceIdSettingsAuditRoute
  WWorkspaceIdSettingsAutomationsRoute: typeof WWorkspaceIdSettingsAutomationsRoute
  WWorkspaceIdSettingsGeneralRoute: typeof WWorkspaceIdSettingsGeneralRoute
  WWorkspaceIdSettingsImportRoute: typeof WWorkspaceIdSettingsImportRoute
  WWorkspaceIdSettingsIntegrationsRoute: typeof WWorkspaceIdSettingsIntegrationsRoute
  WWorkspaceIdSettingsMembersRoute: typeof WWorkspaceIdSettingsMembersRoute
  WWorkspaceIdSettingsNotificationsRoute: typeof WWorkspaceIdSettingsNotificationsRoute
  WWorkspaceIdSettingsTeamsRoute: typeof WWorkspaceIdSettingsTeamsRoute
  WWorkspaceIdSettingsTemplatesRoute: typeof WWorkspaceIdSettingsTemplatesRoute
  WWorkspaceIdTTaskIdRoute: typeof WWorkspaceIdTTaskIdRoute
}

const WWorkspaceIdRouteChildren: WWorkspaceIdRouteChildren = {
  WWorkspaceIdChatRoute: WWorkspaceIdChatRouteWithChildren,
  WWorkspaceIdClipsRoute: WWorkspaceIdClipsRouteWithChildren,
  WWorkspaceIdDashboardsRoute: WWorkspaceIdDashboardsRouteWithChildren,
  WWorkspaceIdDocsRoute: WWorkspaceIdDocsRouteWithChildren,
  WWorkspaceIdEverythingRoute: WWorkspaceIdEverythingRoute,
  WWorkspaceIdFormsRoute: WWorkspaceIdFormsRouteWithChildren,
  WWorkspaceIdHomeRoute: WWorkspaceIdHomeRoute,
  WWorkspaceIdInboxRoute: WWorkspaceIdInboxRoute,
  WWorkspaceIdOfficeRoute: WWorkspaceIdOfficeRouteWithChildren,
  WWorkspaceIdPlannerRoute: WWorkspaceIdPlannerRoute,
  WWorkspaceIdTimesheetRoute: WWorkspaceIdTimesheetRoute,
  WWorkspaceIdTrashRoute: WWorkspaceIdTrashRoute,
  WWorkspaceIdWhiteboardsRoute: WWorkspaceIdWhiteboardsRouteWithChildren,
  WWorkspaceIdIndexRoute: WWorkspaceIdIndexRoute,
  WWorkspaceIdFFolderIdRoute: WWorkspaceIdFFolderIdRoute,
  WWorkspaceIdLListIdRoute: WWorkspaceIdLListIdRoute,
  WWorkspaceIdMyAssignedRoute: WWorkspaceIdMyAssignedRoute,
  WWorkspaceIdMyPersonalRoute: WWorkspaceIdMyPersonalRoute,
  WWorkspaceIdMyTodayRoute: WWorkspaceIdMyTodayRoute,
  WWorkspaceIdSSpaceIdRoute: WWorkspaceIdSSpaceIdRoute,
  WWorkspaceIdSettingsAuditRoute: WWorkspaceIdSettingsAuditRoute,
  WWorkspaceIdSettingsAutomationsRoute: WWorkspaceIdSettingsAutomationsRoute,
  WWorkspaceIdSettingsGeneralRoute: WWorkspaceIdSettingsGeneralRoute,
  WWorkspaceIdSettingsImportRoute: WWorkspaceIdSettingsImportRoute,
  WWorkspaceIdSettingsIntegrationsRoute: WWorkspaceIdSettingsIntegrationsRoute,
  WWorkspaceIdSettingsMembersRoute: WWorkspaceIdSettingsMembersRoute,
  WWorkspaceIdSettingsNotificationsRoute:
    WWorkspaceIdSettingsNotificationsRoute,
  WWorkspaceIdSettingsTeamsRoute: WWorkspaceIdSettingsTeamsRoute,
  WWorkspaceIdSettingsTemplatesRoute: WWorkspaceIdSettingsTemplatesRoute,
  WWorkspaceIdTTaskIdRoute: WWorkspaceIdTTaskIdRoute,
}

const WWorkspaceIdRouteWithChildren = WWorkspaceIdRoute._addFileChildren(
  WWorkspaceIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DevRoute: DevRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  UnsubscribedRoute: UnsubscribedRoute,
  FSlugRoute: FSlugRoute,
  InviteTokenRoute: InviteTokenRoute,
  WWorkspaceIdRoute: WWorkspaceIdRouteWithChildren,
  ShareClipTokenRoute: ShareClipTokenRoute,
  ShareDocTokenRoute: ShareDocTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
